import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useGetPromoEventsQuery } from 'store/api/tournamentService/promoLobbyController';
import { userSelector } from 'store/slices/user';

const useGetTournaments = () => {
  const userInfo = useSelector(userSelector.getInfo);

  const { data } = useGetPromoEventsQuery(
    { userId: userInfo?.id },
    { skip: !userInfo?.id },
  );

  return useMemo(() => data?.events, [data]);
};

export default useGetTournaments;
